'use client';

import { signIn } from 'next-auth/react';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import { ACCOUNT_SWITCH_START_PATH } from '@paeffgen/react/crm-documents/feature-auth';

/**
 * Login-Einstieg. Logo, Titel „Päffgen Kundenportal" und Beschreibung liefert die
 * umgebende AuthShell — hier nur noch Anmelde-Button + Registrieren-Hinweis.
 */
export function RegisterLanding() {
  // Set by middleware.ts when an unauthenticated user is redirected here from a
  // protected deeplink (e.g. /belege/{id}), so we can send them back after login.
  const callbackUrl = useSearchParams().get('callbackUrl') ?? undefined;

  return (
    <div className="text-center">
      <button
        type="button"
        onClick={() => signIn('keycloak', callbackUrl ? { callbackUrl } : undefined)}
        className="w-full rounded-lg bg-[color:var(--color-primary)] px-4 py-3 font-medium text-white"
      >
        Anmelden
      </button>
      <p className="mt-6 text-sm text-[color:var(--color-text-muted)]">
        Noch kein Zugang?{' '}
        <Link href="/register" className="font-medium text-[color:var(--color-primary)] underline">
          Registrieren
        </Link>
      </p>
      {/*
        Ausweg aus der lebenden Keycloak-SSO-Session: „Anmelden" führt sonst
        stillschweigend zurück ins zuletzt genutzte Konto. Bewusst ein echter
        Link (kein Button) — die Route ist ein GET-Endpunkt und der Weg führt
        auf eine fremde Origin. Details: switch-account.ts.
      */}
      <p className="mt-2 text-xs text-[color:var(--color-text-muted)]">
        Falsches Konto?{' '}
        <a
          href={ACCOUNT_SWITCH_START_PATH}
          className="underline hover:text-[color:var(--color-primary)]"
        >
          Mit anderem Konto anmelden
        </a>
      </p>
    </div>
  );
}
